import React from 'react'

const Accred = ({index, src, alt}) => {
  return (
    <li key={index}><img src={src} alt={alt} className="accreds" /></li>
  )
}

export default Accred